import { Injectable } from '@angular/core';
import { AuthHttp, JwtHelper } from 'angular2-jwt';
import { HttpClient } from '@angular/common/http';
import * as _ from 'underscore';
import * as moment from 'moment'
import { environment } from '../../environments/environment';
import { Cookie } from 'ng2-cookies';

import 'rxjs/add/operator/map'
import 'rxjs/add/operator/toPromise';


@Injectable()
export class ApiService {

	private endpoint = environment.apiEndpoint
	private loginEndpoint = environment.membrsEndpoint
  private loginPage = environment.membrsLoginPage
  private cookieDomain = environment.cookieDomain

  private _token:string
  
  constructor(private jwtHelper: JwtHelper, private authHttp: AuthHttp, private http: HttpClient) {


  }

  decode(){
  	if(!this.token)
  		return
  	// var result = this.jwtHelper.decodeToken(this.token)
    var base64Url = this.token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    var result = JSON.parse(jsonPayload);

  	return result
  }

  reissue(token){
    // returns a promise
    console.log('in reissue token');
    return new Promise((resolve, reject) => {
      this.token = token;
      resolve(this.token);
    });
   

    // return new Promise((resolve, reject) => {
    //   this.http.get(this.loginEndpoint+'/token/'+token+'/reissue').subscribe((data:any) => {

    //     this.token = data.token
    //     resolve(data.token)
    //   }, err => {
    //     console.log('token rejected');
    //     reject()
    //   });

    // })

  }

  logout(){
//
      
      localStorage.clear();
      
      if(window.location.hostname == 'nextgen.marketplace.worryandpeace.com'){
        window.location.href = 'https://apollo11.gonextgen.co.uk'
      }
      else
      {
        window.location.href = this.loginPage
      }
 
  }

  set token(token){

    console.log(token,'Token in set token');

    this._token = token

    Cookie.set('membrs',token,1,'/',this.cookieDomain);

  }

  setAdminId(){

    localStorage.setItem('adminId', this.decode().adminId);
  
  }

  get token(){

 
    // to-do: check that the token is valid
    if(!Cookie.check('membrs')){
      this.logout();
    }

    // if(this.jwtHelper.isTokenExpired(Cookie.get('membrs')) == true){
    //   console.log('Token is expired');
    //   this.logout();
    // }


  	return Cookie.get('membrs')
  }

  get adminId(){

    var adminId = this.decode().adminId

    return adminId;
  }


  get loginUrl(){
    return this.loginPage
  }

  get apiEndpoint(){

    return this.endpoint;
  }


  request(method:string, path:string, params?:any, body?:any):Promise<any>{

    if(path.startsWith('http')){
      var endpoint = '';
    }
    else
    {
      var endpoint = this.endpoint;
    }

  	_.each(params, (value, key)=> {
	    path = path.replace(new RegExp(':'+key+'(\\W|$)', 'g'), function(match, p1) {
	        return value + p1;
	    });	    
    });
    

  	// switch method
  	switch(method){

  		case 'GET':
  			return this.authHttp.get(endpoint+path)
		      .toPromise().then(this.extractData)
          .catch(this.handleError)

  		case 'POST':

  			return this.authHttp.post(endpoint+path, body)
        .toPromise().then(this.extractData)
        .catch(this.handleError)
		  
  		case 'PUT':

      return this.authHttp.put(endpoint+path, body)
        .toPromise().then(this.extractData)
        .catch(this.handleError)

  		case 'DELETE':

      return this.authHttp.delete(endpoint+path)
          .toPromise().then(this.extractData)
          .catch(this.handleError)

  		default: 

  		break;
  	}

  } 



  

  // addPod(pod): Promise<any>{
  //         return this._http.post(this._url, pod).toPromise().then(this.extractData)
  //         .catch(this.handleError)
  //     }

  private extractData(value: any) {

    if(value._body.length == 0 && value.status == 200){
        return { status: value.status };
    }
    else{

        let json = value.json()

         if(json.data !== null){
        try{
          let body = json.data;
          if(json.message && json.data)
            body.response_message = json.message
          // to-do: get rid of this
            body.status = value.status
          return body
        }catch(error){

          return { status: value.status }
        }
      }
      else{
        
        return { status: value.status }
      }
      
    }

        
  }

  private handleError(error:any): Promise<any> {
        console.log(error,'Error passed into handlError')
        if(!error.message){
          var body = JSON.parse(error._body)
          error.message = body.message
        }
        return Promise.reject(error.message || 'An unknown error occured, please try again');
    
  }

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/api-service/api.service.ts